import { all } from 'redux-saga/effects';

import addNewWizzardSaga from './connect-wizzard/add-new-wizzard.sagas';
import clientSaga from './client/sagas';
import entitiesBatchSaga from './entitiesBatch/sagas';
import benchmarkSaga from './benchmark/sagas';
import overviewSaga from './overview/sagas';
import wizzardSaga from './connect-wizzard/sagas';
import overallStatsSaga from './overallStats/sagas';
import clientsRequiringAttentionSaga from './clientsRequiringAttention/sagas';
import clientsTotalSaga from './clientsTotal/sagas';
import productMatchesSaga from './productMatches/sagas';
import conversationsSaga from './conversations/sagas';
import clientTagsSaga from './tags/sagas';
import timelineSaga from './timeline/sagas';

export default function* dashboardSaga() {
  return yield all([
    addNewWizzardSaga(),
    clientSaga(),
    overviewSaga(),
    wizzardSaga(),
    overallStatsSaga(),
    clientsTotalSaga(),
    entitiesBatchSaga(),
    benchmarkSaga(),
    clientsRequiringAttentionSaga(),
    productMatchesSaga(),
    conversationsSaga(),
    clientTagsSaga(),
    timelineSaga(),
  ]);
}
